import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { api_subscribeToNewsletter } from '~/backend/api_calls';
import { validateGuestUserEmail } from '~/core/checkout/utils/checkout_step_1';
import check from '~/images/blue-check.svg';
import Button from './Button';
import Checkbox from './Checkbox';
import Modal from './Modal';
import { notifyError, notifyInfo } from './ToastMessages';

const CouponPopup = () => {
	const { t } = useTranslation();
	const [couponPopupVisible, setCouponPopupVisible] = useState(false);
	const showCouponPopup = useSelector(state => state.layoutReducer.showCouponPopup);
	const [email, setEmail] = useState('');
	const [acceptedNewsletterTerms, setAcceptedNewsletterTerms] = useState(false);
	const [acceptedPrivacyTerms, setAcceptedPrivacyTerms] = useState(false);

	useEffect(() => {
		let closeDate = localStorage.getItem(`couponpopup_close_date`);

		if (!showCouponPopup) return;

		if (closeDate) {
			const validDate = new Date(closeDate);
			validDate.setDate(validDate.getDate() + 5);

			if (validDate < new Date()) {
				setTimeout(() => {
					setCouponPopupVisible(true);
				}, 4000);
			}
		} else {
			setTimeout(() => {
				setCouponPopupVisible(true);
			}, 4000);
		}
	}, [showCouponPopup]);

	const handleCloseCouponPopup = () => {
		setCouponPopupVisible(false);
		localStorage.setItem(`couponpopup_close_date`, new Date());
	};

	const handleSubscribeToNewsletter = () => {
		if (!validateGuestUserEmail(email)) {
			notifyError(t('validation_email'));
			return;
		}

		if (!acceptedNewsletterTerms) {
			notifyError(t('accept_newsletter_policy_error'));
			return;
		}

		if (!acceptedPrivacyTerms) {
			notifyError(t('accept_policy_error'));
			return;
		}

		api_subscribeToNewsletter(email)
			.then(json => notifyInfo(json))
			.catch(err => console.error(err));

		handleCloseCouponPopup();
	};

	return (
		<div className="coupon-poupup-modal">
			<Modal open={couponPopupVisible} setOpen={handleCloseCouponPopup} className="coupon-popup">
				<div className="coupon-popup-container">
					<div className="header">
						<div className="title">
							<span>10€</span> έκπτωση στην 1η σου αγορά
						</div>
					</div>
					<div className="body">
						<h4>Συμπλήρωσε το email σου για να κερδίσεις:</h4>
						<ul className="coupon-features">
							<li>
								<img src={check} alt="check" />
								<h5>Eκπτωτικούς Κωδικούς</h5>
							</li>
							<li>
								<img src={check} alt="check" />
								<h5>10€ στην πρώτη σου αγορά</h5>
							</li>
							<li>
								<img src={check} alt="check" />
								<h5>Πρόσβαση σε αποκλειστικά προϊόντα</h5>
							</li>
						</ul>

						<input
							className="email"
							type="text"
							value={email}
							onChange={e => setEmail(e.target.value)}
							placeholder={t('footer_newsletter_input_placeholder')}
						/>

						<div className="checkboxes-container">
							<Checkbox
								label="Συμφωνώ με τους Όρους & Προϋποθέσεις για αγορές."
								checked={acceptedPrivacyTerms}
								onChange={() => setAcceptedPrivacyTerms(!acceptedPrivacyTerms)}
							/>
							<Checkbox
								label="Θέλω να λαμβάνω ενημερωτικά emails, προσφορές και εκπτωτικούς κωδικούς."
								checked={acceptedNewsletterTerms}
								onChange={() => setAcceptedNewsletterTerms(!acceptedNewsletterTerms)}
							/>
						</div>
					</div>

					<div className="footer">
						<Button color="secondary" actionOnClick={handleSubscribeToNewsletter}>
							ΕΓΓΡΑΦΗ
						</Button>
					</div>
				</div>
			</Modal>
		</div>
	);
};

CouponPopup.propTypes = {};

export default CouponPopup;
